module.exports = __webpack_public_path__ + "static/bg-edu2-f23297c3bb88a5e876f504ac1315cb6e.jpg";